import { APIConfiguration } from '@savgroup-front-common/configuration';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
  ModelDimension,
} from '@savgroup-front-common/types';

interface CreateProductReferencePayload {
  modelId: string;
  sellerId: string | undefined;
  name: string;
  brandId: string;
  modelTypeId: string;
  weight: number;
  sku: string;
  ean: string;
  additionalReturnInfo: {
    isReturnable: boolean;
    isRepairable: boolean;
    isTransportable: boolean;
  };
  isFiltering: boolean;
  dimension: ModelDimension;
  state: string;
  isLowValue: boolean;
  assemblingSKU: string[];
}
const ENDPOINT = `${APIConfiguration.catalog}models`;

async function upsertModelCommand(
  payload: CreateProductReferencePayload,
): Promise<BackResponse<CreateProductReferencePayload> | BackResponseFailure> {
  try {
    const response = await apiCall<BackResponse<CreateProductReferencePayload>>(
      ENDPOINT,
      {
        method: SUPPORTED_METHODS.PUT,
        json: payload,
      },
    );

    return response;
  } catch (error) {
    return prepareResponseFailure(error);
  }
}

export default upsertModelCommand;
